"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const react_flow_renderer_1 = __importStar(require("react-flow-renderer"));
require("react-flow-renderer/dist/style.css");
const CustomNode_1 = __importDefault(require("../customNode/CustomNode"));
const team_management_pathway_svg_1 = __importDefault(require("../../../assets/images/pathways/team-management-pathway.svg"));
const business_leadership_pathway_svg_1 = __importDefault(require("../../../assets/images/pathways/business-leadership-pathway.svg"));
const management_accelerator_pathway_svg_1 = __importDefault(require("../../../assets/images/pathways/management-accelerator-pathway.svg"));
const CircleDotNode_1 = __importDefault(require("../circleDotNode/CircleDotNode"));
require("./pathwayFlow.scss");
const FlowRightInfoContainer_1 = __importDefault(require("../flowRightInfoContainer/FlowRightInfoContainer"));
const pathwayFlowTranslations_json_1 = __importDefault(require("./pathwayFlowTranslations/pathwayFlowTranslations.json"));
const PathwayMobileBottomSheet_1 = __importDefault(require("../pathwayMobileBottomSheet/PathwayMobileBottomSheet"));
// Define a descriptive constant for the start node ID to eliminate magic strings
const START_NODE_ID = "pathway-flow-start-node";
const initialNodes = [
    {
        id: START_NODE_ID,
        type: "circleDotNode",
        data: {},
        position: { x: 300, y: 0 },
    },
];
const initialEdges = [];
const defaultEdgeOptions = {
    animated: false,
};
const nodeTypes = {
    textUpdater: CustomNode_1.default,
    circleDotNode: CircleDotNode_1.default,
};
function PathwayFlow(props) {
    props.addTranslation(pathwayFlowTranslations_json_1.default);
    const [selectedNode, setSelectedNode] = (0, react_2.useState)(null);
    const [nodes, setNodes] = (0, react_2.useState)(initialNodes);
    const [edges, setEdges] = (0, react_2.useState)(initialEdges);
    (0, react_1.useEffect)(() => {
        updateNodes();
    }, [props.pathway, props.translate, props.addTranslation]);
    const dummyImages = [
        team_management_pathway_svg_1.default,
        business_leadership_pathway_svg_1.default,
        management_accelerator_pathway_svg_1.default,
    ];
    function updateNodes() {
        console.log("updateNodes init", props.pathway);
        const newNodes = props.pathway.campaigns.map((campaign, index) => {
            var _a;
            return {
                id: campaign.id,
                type: "textUpdater",
                data: Object.assign(Object.assign({}, campaign), { recipientText: props.translate("recipientReceived", {
                        recipientCount: ((_a = campaign.campaign) === null || _a === void 0 ? void 0 : _a.recipientCount) || 0,
                    }) }),
                position: {
                    x: (campaign.xPosition - 1) * 500,
                    y: (campaign.yPosition - 1) * 400,
                },
            };
        });
        console.log("newNodes", newNodes);
        setNodes(newNodes);
        updateEdges(newNodes);
    }
    // Helper function to recursively extract all campaign IDs from automation rules
    function extractPrerequisiteCampaignIds(rule) {
        var _a;
        const campaignIds = new Set();
        // If this rule has a campaign directly, add its ID
        if ((_a = rule.campaign) === null || _a === void 0 ? void 0 : _a.id) {
            campaignIds.add(rule.campaign.id);
        }
        // Recursively process OR rules
        if (rule.or) {
            rule.or.forEach(orRule => {
                const nestedIds = extractPrerequisiteCampaignIds(orRule);
                nestedIds.forEach(id => campaignIds.add(id));
            });
        }
        // Recursively process AND rules
        if (rule.and) {
            rule.and.forEach(andRule => {
                const nestedIds = extractPrerequisiteCampaignIds(andRule);
                nestedIds.forEach(id => campaignIds.add(id));
            });
        }
        return campaignIds;
    }
    function updateEdges(nodes) {
        const circleNodeId = START_NODE_ID;
        const newEdges = [];
        const edgeSet = new Set(); // Track unique edges (bidirectional)
        console.log("updateEdges - pathway campaigns:", props.pathway.campaigns);
        // Helper function to create a unique edge key (bidirectional)
        const createEdgeKey = (sourceId, targetId) => {
            return [sourceId, targetId].sort().join('|');
        };
        // Loop through each campaign once - ONLY create edges based on automationRules
        props.pathway.campaigns.forEach(campaign => {
            var _a, _b, _c;
            if ((_a = campaign.automationRules) === null || _a === void 0 ? void 0 : _a.or) {
                console.log(`Campaign ${(_b = campaign.campaign) === null || _b === void 0 ? void 0 : _b.title} has automation rules:`, campaign.automationRules);
                // Extract all prerequisite campaign IDs from the automation rules
                const prerequisiteIds = new Set();
                campaign.automationRules.or.forEach(rule => {
                    const rulePrerequisites = extractPrerequisiteCampaignIds(rule);
                    rulePrerequisites.forEach(id => prerequisiteIds.add(id));
                });
                console.log(`Prerequisites for ${(_c = campaign.campaign) === null || _c === void 0 ? void 0 : _c.title}:`, Array.from(prerequisiteIds));
                // For each prerequisite, create edge from prerequisite (source) to current campaign (target)
                prerequisiteIds.forEach(prerequisiteId => {
                    var _a, _b;
                    // Find the pathway campaign wrapper that contains this prerequisite campaign ID
                    const prerequisiteCampaignWrapper = props.pathway.campaigns.find(c => { var _a; return ((_a = c.campaign) === null || _a === void 0 ? void 0 : _a.id) === prerequisiteId; });
                    if (prerequisiteCampaignWrapper) {
                        const sourceId = prerequisiteCampaignWrapper.id;
                        const targetId = campaign.id;
                        const edgeKey = createEdgeKey(sourceId, targetId);
                        // Only add if this edge doesn't already exist (bidirectional check)
                        if (!edgeSet.has(edgeKey)) {
                            edgeSet.add(edgeKey);
                            newEdges.push({
                                id: `e${sourceId}-${targetId}`,
                                source: sourceId,
                                target: targetId,
                                sourceHandle: "right-handle",
                                targetHandle: "left-handle",
                                animated: false,
                            });
                            console.log(`Created edge: ${(_a = prerequisiteCampaignWrapper.campaign) === null || _a === void 0 ? void 0 : _a.title} → ${(_b = campaign.campaign) === null || _b === void 0 ? void 0 : _b.title}`);
                        }
                    }
                });
            }
        });
        console.log("Final newEdges:", newEdges);
        setEdges(newEdges);
    }
    const onNodesChange = (0, react_2.useCallback)((changes) => setNodes((nds) => (0, react_flow_renderer_1.applyNodeChanges)(changes, nds)), [setNodes]);
    const onEdgesChange = (0, react_2.useCallback)((changes) => setEdges((eds) => (0, react_flow_renderer_1.applyEdgeChanges)(changes, eds)), [setEdges]);
    const onConnect = (0, react_2.useCallback)((connection) => setEdges((eds) => (0, react_flow_renderer_1.addEdge)(connection, eds)), [setEdges]);
    const onNodeClick = (0, react_2.useCallback)((event, node) => {
        const campaignByNodeId = props.pathway.campaigns.find((campaign) => campaign.id === node.id);
        if (campaignByNodeId) {
            setSelectedNode(campaignByNodeId);
        }
    }, []);
    const onPaneClick = (0, react_2.useCallback)(() => {
        setSelectedNode(null);
    }, []);
    return (react_1.default.createElement("div", { className: `pathway-flow-wrapper ${props.isMobile ? "mobile" : ""}` },
        react_1.default.createElement(react_flow_renderer_1.default, { nodes: nodes, style: {
                height: "500px",
                borderRadius: "8px",
                background: "#F7F7F7",
                maxWidth: props.isMobile ? "100%" : "1180px",
                width: "100%",
            }, nodeTypes: nodeTypes, edges: edges, onNodesChange: onNodesChange, onEdgesChange: onEdgesChange, onConnect: onConnect, fitView: true, defaultEdgeOptions: defaultEdgeOptions, onNodeClick: onNodeClick, onPaneClick: onPaneClick, nodesDraggable: false, nodesConnectable: false, elementsSelectable: false, panOnDrag: true, zoomOnScroll: true, zoomOnPinch: true, zoomOnDoubleClick: true, connectOnClick: false, preventScrolling: true }),
        !props.isMobile ? (react_1.default.createElement(FlowRightInfoContainer_1.default, Object.assign({}, props, { infoNode: selectedNode ? selectedNode : props.pathway }))) : (react_1.default.createElement(PathwayMobileBottomSheet_1.default, Object.assign({}, props, { infoNode: selectedNode ? selectedNode : props.pathway })))));
}
exports.default = PathwayFlow;
